/**
 * Short link context utilities for tracking attribution.
 */

export interface ShortLinkContextValue {
  shortCode?: string;
  southpawJobId?: string;
  attribution: Record<string, string>;
}

/**
 * Get the stored short link context from session storage.
 * This is used for tracking user attribution from short links.
 * @returns The short link context or null if not available
 */
export function getStoredShortLinkContext(): ShortLinkContextValue | null {
  if (typeof window === "undefined") {
    return null;
  }
  const shortCode = sessionStorage.getItem("short_code") || undefined;
  const southpawJobId = sessionStorage.getItem("job_id") || undefined;
  const attributionRaw = sessionStorage.getItem("short_link_attr");
  let attribution: Record<string, string> = {};
  if (attributionRaw) {
    try {
      attribution = JSON.parse(attributionRaw);
    } catch {
      attribution = {};
    }
  }
  if (!shortCode && !southpawJobId) return null;
  return { shortCode, southpawJobId, attribution };
}
